import 'https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.1.0/dist/cookieconsent.umd.js';

CookieConsent.run({
    revision: 1,
    mode: 'opt-in',
    guiOptions: {
        consentModal: {
            layout: "box wide",
            position: "middle center",
            equalWeightButtons: false,
            flipButtons: true
        },
        preferencesModal: {
            layout: "box",
            position: "center",
            equalWeightButtons: false,
            flipButtons: true
        }
    },
    categories: {
        necessary: {
            readOnly: true,
            services: {
                ga: {
                    label: 'Google',
                    cookies: [
                        {
                            name: /^(_ga|_gid)/
                        }
                    ]
                },
                shopify: {
                    label: 'Shopify',
                    cookies: [
                        {
                            name: 'bugsnag-anonymous-id'
                        }
                    ]
                },
                swym: {
                    label: 'Swym',
                    cookies: [
                        {
                            name: /^(swym)/
                        }
                    ]
                },
                pin: {
                    label: 'Pinterest',
                    cookies: [
                        {
                            name: /^(ar_debug)/
                        }
                    ]
                },
                mosz: {
                    label: 'Mosz Accessoires',
                    cookies: [
                        {
                            name: /^(cart_currency|_tracking_consent|secure_customer_sig|shopify_pay_redirect|wpm-test-cookie)/
                        }
                    ]
                },
            }
        },
        preferences: {
            services: {
                klaviyo: {
                    label: 'Klaviyo',
                    cookies: [
                        {
                            name: /^(klaviyoOnsite)/
                        }
                    ]
                },
                mosz: {
                    label: 'Mosz Accessoires',
                    cookies: [
                        {
                            name: 'localization'
                        }
                    ]
                }
            }
        },
        functionality: {
            services: {
                beslist: {
                    label: 'Beslist.nl',
                    cookies: [
                        {
                            name: /^(client_bsls)/
                        }
                    ]
                },
                klaviyo: {
                    label: 'Klaviyo',
                    cookies: [
                        {
                            name: /^(__kla_id)/
                        }
                    ]
                },
                mosz: {
                    label: 'Mosz Accessoires',
                    cookies: [
                        {
                            name: 'theme:recently-viewed-products'
                        }
                    ]
                }
            }
        },
        analytics: {
            services: {
                beslist: {
                    label: 'Meta Platforms, Inc.',
                    cookies: [
                        {
                            name: /^(_fbp)/
                        }
                    ]
                },
                ga: {
                    label: 'Google',
                    cookies: [
                        {
                            name: /^(_ga)/
                        }
                    ]
                },
                klaviyo: {
                    label: 'Klaviyo',
                    cookies: [
                        {
                            name: /^(__kla_viewed)/
                        }
                    ]
                },
                pin: {
                    label: 'Pinterest',
                    cookies: [
                        {
                            name: /^(_pinterest_ct_ua)/
                        }
                    ]
                },
                mosz: {
                    label: 'Mosz Accessoires',
                    cookies: [
                        {
                            name: /^(_landing_page|_orig_referrer|_shopify_y)/
                        }
                    ]
                }
            }
        }
    },
    language: {
        default: "nl",
        autoDetect: "browser",
        translations: {
            nl: {
                consentModal: {
                    title: "Deze website maakt gebruik van cookies",
                    description: "We gebruiken cookies om content en advertenties te personaliseren, om functies voor social media te bieden en om ons websiteverkeer te analyseren. Ook delen we informatie over uw gebruik van onze site met onze partners voor social media, adverteren en analyse.",
                    acceptAllBtn: "Alles toestaan",
                    //acceptNecessaryBtn: "Weigeren",
                    showPreferencesBtn: "Aanpassen"
                    
                },
                preferencesModal: {
                    title: "Details",
                    acceptAllBtn: "Alles toestaan",
                    // acceptNecessaryBtn: "Weigeren",
                    savePreferencesBtn: "Opslaan",
                    closeIconLabel: "Sluiten",
                    serviceCounterLabel: "|",
                    sections: [
                        {
                            title: "Noodzakelijk <span class=\"pm__badge\">Altijd ingechakeld</span>",
                            description: "Noodzakelijke cookies helpen een website bruikbaarder te maken, door basisfuncties als paginanavigatie en toegang tot beveiligde gedeelten van de website mogelijk te maken. Zonder deze cookies kan de website niet naar behoren werken.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Voorkeuren",
                            description: "Voorkeurscookies zorgen ervoor dat een website informatie kan onthouden die van invloed is op het gedrag en de vormgeving van de website, zoals de taal van uw voorkeur of de regio waar u woont.",
                            linkedCategory: "preferences"
                        },
                        {
                            title: "Statistieken",
                            description: "Statistische cookies helpen eigenaren van websites begrijpen hoe bezoekers hun website gebruiken, door anoniem gegevens te verzamelen en te rapporteren.",
                            linkedCategory: "functionality"
                        },
                        {
                            title: "Marketing",
                            description: "Marketingcookies worden gebruikt om bezoekers te volgen wanneer ze verschillende websites bezoeken. Hun doel is advertenties weergeven die zijn toegesneden op en relevant zijn voor de individuele gebruiker. Deze advertenties worden zo waardevoller voor uitgevers en externe adverteerders.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Over",
                            description: `Cookies zijn kleine tekstbestanden die door websites kunnen worden gebruikt om gebruikerservaringen efficiënter te maken.<br/>
                                            <br/>
                                            Volgens de wet mogen wij cookies op uw apparaat opslaan als ze strikt noodzakelijk zijn voor het gebruik van de site. Voor alle andere soorten cookies hebben we uw toestemming nodig.<br/>
                                            <br/>
                                            Deze website maakt gebruik van verschillende soorten cookies. Sommige cookies worden geplaatst door diensten van derden die op onze pagina's worden weergegeven.<br/>
                                            <br/>
                                            Via de cookieverklaring op onze website kunt u uw toestemming op elk moment wijzigen of intrekken.<br/>
                                            <br/>
                                            In ons privacybeleid vindt u meer informatie over wie we zijn, hoe u contact met ons kunt opnemen en hoe we persoonlijke gegevens verwerken.<br/>
                                            <br/>
                                            Als u vragen heeft over uw toestemming, vermeld dan het ID en de datum van de toestemming alstublieft.`
                        }
                    ]
                }
            }
        }
    }
});